import React from 'react';
import PropTypes from 'prop-types';

import { CPage, H2, CCol, CRow, Text } from '@appcues/component-library';
import FirebaseSaveIndicator from 'components/Common/FirebaseSaveIndicator';

export default function IndexPage({
  title,
  description,
  subHeaderActions,
  children,
  shouldHideFirebaseSaveIndicator,
}) {
  const hasTitleOrDescAndSubHeaderActions =
    title || (description && subHeaderActions);

  return (
    <>
      {!shouldHideFirebaseSaveIndicator && <FirebaseSaveIndicator />}
      {hasTitleOrDescAndSubHeaderActions && (
        <CPage.TitleBar data-no-print>
          <CPage.TitleBar.Content>
            <CCol>
              <CRow>
                <H2>{title}</H2>
              </CRow>
              {description && (
                <CRow marginTop="0.5em" fontColor="$gray-1">
                  <Text color="$gray-5">{description}</Text>
                </CRow>
              )}
            </CCol>
          </CPage.TitleBar.Content>
          {subHeaderActions && (
            <CPage.TitleBar.Actions>{subHeaderActions}</CPage.TitleBar.Actions>
          )}
        </CPage.TitleBar>
      )}
      {children}
    </>
  );
}

IndexPage.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  subHeaderActions: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
